import { EMAIL_REGEX } from '@zoopla/shared/forms';

export const isValidEmail = (email: string) => EMAIL_REGEX.test(email);

export const isTestEmail = (email: string) => email.includes('+blacklist');
